import PropTypes from 'prop-types'

import AuthenticatorAppIcon from '../../AuthenticatorAppIcon'
import SmartphoneIcon from './SmartphoneIcon'
import TfaWizardStepFrame from './TfaWizardStepFrame'

const DEFAULT_METHODS = [
  {
    description: 'Receive verification codes via message to your phone',
    Icon: SmartphoneIcon,
    id: 'phone',
    label: 'Phone (SMS/Voice)'
  },
  {
    description: 'Use an app like Google Authenticator or Authy to generate verification codes',
    Icon: AuthenticatorAppIcon,
    id: 'app',
    label: 'Authenticator app'
  }
]

const TfaMethodSelectionStep = props => (
  <TfaWizardStepFrame
    currentStep={1}
    onPrimaryAction={props.onNext}
    onSecondaryAction={props.onCancel}
    primaryActionLabel='Next'
    primaryLoading={props.loading}
    secondaryActionLabel='Cancel'
    subtitle="Select how you'd like to verify your identity when signing in."
    title='Choose your authentication method'>
    <div className='tfa-method-selection'>
      {
        props.methods.map(method => {
          const isSelected = props.selectedMethod === method.id
          const MethodIcon = method.Icon

          return (
            <button
              aria-pressed={isSelected}
              className={`tfa-method-card ${isSelected ? 'tfa-method-card-selected' : ''}`.trim()}
              key={method.id}
              onClick={() => props.onSelectMethod(method.id)}
              type='button'>
              <span className='tfa-method-card-icon'>
                <MethodIcon />
              </span>
              <span className='tfa-method-card-copy'>
                <span className='tfa-method-card-label-row'>
                  <span className='tfa-method-card-label'>{method.label}</span>
                </span>
                <span className='tfa-method-card-description'>{method.description}</span>
              </span>
            </button>
          )
        })
      }
    </div>
  </TfaWizardStepFrame>
)

TfaMethodSelectionStep.propTypes = {
  methods: PropTypes.arrayOf(PropTypes.shape({
    description: PropTypes.string,
    Icon: PropTypes.elementType,
    id: PropTypes.string,
    label: PropTypes.string
  })),
  onCancel: PropTypes.func,
  onNext: PropTypes.func,
  onSelectMethod: PropTypes.func,
  selectedMethod: PropTypes.string
}

TfaMethodSelectionStep.defaultProps = {
  methods: DEFAULT_METHODS,
  onCancel: null,
  onNext: null,
  onSelectMethod: null,
  selectedMethod: 'phone'
}

export default TfaMethodSelectionStep
